export default {
  activeGameSet: new Set([]),
};
